import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import LoadJquery from "../helper/LoadJquery";
import Carousal from "../mini_components/Carousal";
import VisitorTracker from '../components/VisitorTracker';
import useContactForm from '../hooks/useContactForm';
import { useState } from "react";

function Home() {
  // Validation, submit guarding, per-field errors and form analytics all live
  // in the shared hook. The source page name is what lets the admin console
  // attribute this lead to the right page.
  const {
    formData, errors, isLoading, handleSubmit, handleInputChange, fieldProps,
  } = useContactForm("home");

  // Renders the message under a field, and nothing when it is valid.
  const Err = ({ name }) =>
    errors[name] ? (
      <p className="form-field-error" id={`${name}-error`} role="alert">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />{" "}
        {errors[name]}
      </p>
    ) : null;


  // NEW: State for loading

  // State for counter values
  const [counters, setCounters] = useState({
    clients: 0,
    employees: 0,
    programs: 0,
    exams: 0
  });

  // Ref for counter section
  const counterRef = useRef(null);

  // NEW: Custom debounce function

  // NEW: Handle input changes

  // NEW: Handle form submission

  // NEW: Debounced submit handler (500ms delay)

  // Manual count-up function
  const startCountUp = (targetValues, duration = 2000) => {
    const startTime = performance.now();
    const increment = 10; // Update every 10ms

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // Normalize to 0-1

      setCounters({
        clients: Math.ceil(targetValues.clients * progress),
        employees: Math.ceil(targetValues.employees * progress),
        programs: Math.ceil(targetValues.programs * progress),
        exams: Math.ceil(targetValues.exams * progress)
      });

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  };

  // Intersection Observer to trigger count-up when section is visible
  useEffect(() => {
    let hasAnimated = false;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          startCountUp({
            clients: 100,
            employees: 50,
            programs: 70,
            exams: 300
          });
          hasAnimated = true;
          observer.disconnect();
        }
      },
      { threshold: [0.1, 0.5] } // Trigger at 10% or 50% visibility
    );

    // Fallback: Start animation if section is already in viewport or observer fails
    const checkInitialVisibility = () => {
      if (counterRef.current && !hasAnimated) {
        const rect = counterRef.current.getBoundingClientRect();
        const isVisible = (
          rect.top >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        );
        if (isVisible) {
          startCountUp({
            clients: 100,
            employees: 50,
            programs: 70,
            exams: 300
          });
          hasAnimated = true;
          observer.disconnect();
        }
      }
    };

    // Observe the counter section
    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    // Check visibility after a short delay to handle initial load on mobile
    const timer = setTimeout(checkInitialVisibility, 500);

    return () => {
      clearTimeout(timer);
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  return (
    <>
    <LoadJquery />
    <VisitorTracker page="home" />
    <div className="index-one">
      <Carousal />
      {/* tpm-header-area start */}
      {/* tpm-header-area start */}

      {/* tpm-header-area end */}

     

      {/* Tpm About Area Start  */}
      <div className="about-area tmp-section-gap about-style-one" >
        <div className="container">
          <div className="row align-items-center">
            {/* <div className="col-lg-6">
              <div className="about-thumbnails">
                <div className="thumbnail">
                  <img
                    src={require("../assets/images/about/01.png")}
                    alt="corporate_business"
                  />

                  <div className="image-two">
                    <img
                      src={require("../assets/images/about/03.png")}
                      alt="corporate_business"
                    />
                  </div>

                  <div className="image-three animated">
                    <img
                      className=""
                      src={require("../assets/images/about/02.png")}
                      alt="corporate_business"
                    />
                  </div>

                  <div className="square"></div>

                  <div className="flower">
                    <img
                      src={require("../assets/images/about/flower.png")}
                      alt="Corporate_Business"
                    />
                  </div>

                  <div className="product-share">
                    <div className="rating">
                      <div className="number">4.8</div>
                      <div className="stars-group">
                        <div className="star">
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>

                          <i className="fa-solid fa-star-half-stroke"></i>
                        </div>
                      </div>
                    </div>
                    <div className="profile-share">
                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img
                          src={require("../assets/images/about/4.png")}
                          alt="Business_Corporate"
                        />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img
                          src={require("../assets/images/about/5.png")}
                          alt="Business_Corporate"
                        />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img
                          src={require("../assets/images/about/6.png")}
                          alt="Business_Corporate"
                        />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img
                          src={require("../assets/images/about/7.png")}
                          alt="Business_Corporate"
                        />
                      </Link>
                    </div>
                  </div>
                </div>

                video icon
                <div
                  className="vedio-icone"
                  data-tmp-cursor="lg"
                  data-tmp-cursor-text="Play Video"
                >
                  <Link className="video-play-button play-video" to="#">
                    <span></span>
                  </Link>
                  <div className="video-overlay">
                    <Link className="video-overlay-close">×</Link>
                  </div>
                </div>
                video icon
              </div>
            </div> */}
            <div >




              <div className="about-inner">
                <div className="section-head text-align-left section-head-one-side">
                  <div className="section-sub-title">
                    <img
                      src={require("../assets/images/services/section-custom-menubar.png")}
                      alt="Corporate_service"
                    />
                    <span className="subtitle">ABOUT US</span>
                  </div>
                  <h2 className="title split-collab">
                    Find out more about our <br></br> services and solutions
                  </h2>
                </div>

                <p
                  className="description"
                  data-sal-delay="200"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  Starparth is a next-generation technology and business solutions company. We empower organizations to evolve and excel—across IT infrastructure, digital experiences, and strategic planning. With our unique blend of technical expertise and business insight, we deliver cutting-edge IT Solutions, reliable Online/Offline Exam Infra Services, smart Financial & Investment Planning, and result-driven Digital Marketing Solutions. At Starparth, we help you move forward—faster and smarter.
                </p>
                {/* Prograss bar Start  */}
                <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="250"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name"> Infra Consulting </p>
                    <span className="parcent">97%</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: "97%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="300"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name">IT Consulting</p>
                    <span className="parcent">90%</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: "90%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                  <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="300"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name">Finance Consulting</p>
                    <span className="parcent">90%</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: "90%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                 <div
                  className="single-progress-area progress-stye-one"
                  data-sal-delay="300"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="progress-top">
                    <p className="name">Digital Marketing Solutions</p>
                    <span className="parcent">80%</span>
                  </div>
                  <div className="progress">
                    <div
                      className="progress-bar wow fadeInLeft bg--primary"
                      role="progressbar"
                      style={{ width: "80%" }}
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                {/* Prograss bar End  */}
                <div
                  className="thumbnail-with-title"
                  data-sal-delay="350"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  {/* <div className="thumbnail">
                    <img
                      src={require("../assets/images/about/about-with-icon.png")}
                      alt=""
                    />
                    <div className="icon">
                      <i className="fa-regular fa-dollar-sign"></i>
                    </div>
                  </div>
                  <div className="title">
                    Helping you run a more efficient & profitable business.
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*Tpm About Area End  */}

      {/* Tmp services area  */}
      <div className="tmp-services-area services-style--1 background-image-services bg_image tmp-section-gap">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Business_Consulting_services"
                  />
                  <span>OUR SERVICES</span>
                </div>
                <h2 className="title split-collab">Our Provided Services</h2>
              </div>
            </div>
          </div>

          <div className="row g-4 ">
            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="single-services service-style-one">
                <div className="services-inner  with-shadow card-bg-color">
                  <div className="thumbnail">
                    <img
                      src={require("../assets/images/services/services-icon-1.png")}
                      alt="Business consulting services"
                    />
                  </div>
                  <div className="services-content">
                    <Link to="/agency">
                      <h5 className="title">Exam Infra Consulting</h5>
                    </Link>
                    <p className="desctiption">
                      Secure, scalable exam infra. Online/offline setups with monitoring, ID checks, and execution across platforms.
                    </p>

                    <Link to="/agency" className="icon angle-roted">
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
                  {/* <div className="number">
                    <img
                      src={require("../assets/images/services/icon-01.png")}
                      alt="Business Consulting number"
                    />
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="single-services service-style-one">
                <div className="services-inner  with-shadow card-bg-color">
                  <div className="thumbnail">
                    <img
                      src={require("../assets/images/services/services-icon-2.png")}
                      alt="Business consulting services"
                    />
                  </div>
                  <div className="services-content">
                    <Link to="/itconsulting">
                      <h5 className="title">IT Consulting</h5>
                    </Link>
                    <p className="desctiption">
                      Powering digital growth with smart IT, agile systems, cloud, and automation. Scalable, secure, and future-ready tech.
                    </p>

                    <Link to="/itconsulting" className="icon angle-roted">
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>

                  {/* <div className="number">
                    <img
                      src={require("../assets/images/services/icon-02.png")}
                      alt="Business Consulting number"
                    />
                  </div> */}
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="single-services service-style-one">
                <div className="services-inner  with-shadow card-bg-color">
                  <div className="thumbnail">
                    <img
                      src={require("../assets/images/services/services-icon-3.png")}
                      alt="Business consulting services"
                    />
                  </div>
                  <div className="services-content">
                    <Link to="/financial">
                      <h5 className="title">Financial Consulting</h5>
                    </Link>
                    <p className="desctiption">
                      Smart financial planning and investments. Goal-driven, risk-aware, and growth-focused wealth strategies for life and business.
                    </p>

                    <Link to="/financial" className="icon angle-roted">
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>
{/* 
                  <div className="number">
                    <img
                      src={require("../assets/images/services/icon-03.png")}
                      alt="Business Consulting number"
                    />
                  </div> */}
                </div>
              </div>
            </div>
             <div className="col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="single-services service-style-one">
                <div className="services-inner  with-shadow card-bg-color">
                  <div className="thumbnail">
                    <img
                      src={require("../assets/images/services/services-icon-3.png")}
                      alt="Business consulting services"
                    />
                  </div>
                  <div className="services-content">
                    <Link to="/marketing">
                      <h5 className="title">Digital Marketing</h5>
                    </Link>
                    <p className="desctiption">
                      Boost brand visibility. Data-led SEO, ads, content, and campaigns that engage, convert, and scale online.
                    </p>

                    <Link to="/marketing" className="icon angle-roted">
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>

                  {/* <div className="number">
                    <img
                      src={require("../assets/images/services/icon-03.png")}
                      alt="Business Consulting number"
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="services-bottom">
                <div className="services-bottom-inner">
                  <p className="description">
                    Our success as consultants will depend on the essential
                    rightness of the advice.
                  </p>
                  <p className="description">
                    Want to learn more About us?
                    <button className="btn-simple">Click here</button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tmp services area end */}

      {/* Tmp Servisec Processs Area Two Start */}
      <div
        style={{ opacity: 1 , marginBottom : "50px"}}
        className="tpm-services-process-area tmp-section-gap"
      >
        <div style={{ opacity: 1 }} className="container">
          <div
            style={{ opacity: 1 }}
            className="row"
            data-sal-delay="150"
            data-sal="slide-up"
            data-sal-duration="800"
          >
            <div style={{ opacity: 1 }} className="col-lg-12">
              <div style={{ opacity: 1 }} className="section-head">
                <div
                  style={{ opacity: 1 }}
                  className="section-sub-title center-title"
                >
                  <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Corporate_service"
                  />
                  <span className="subtitle">OUR work process</span>
                </div>
                <h2 className="title split-collab">How Our Services Work</h2>
              </div>
            </div>
          </div>

          <div style={{ opacity: 1 }} className="row g-5">
            <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={{ opacity: 1 }} className="single-services">
                <div className="services-inner">
                  <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                    <Link to="#">
                      <img
                        src={require("../assets/images/services/services-round-1.png")}
                        alt="Business consulting services"
                      />
                    </Link>
                    <div className="number-bg-round">
                      <span>01</span>
                    </div>
                  </div>
                  <div className="services-content services-content-style-1 text-center">
                    <h5 className="title">Meeting Client</h5>
                    <p className="description">
                      Understanding client goals, challenges, and vision through focused discussions to align solutions with their unique business needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-services">
                <div className="services-inner">
                  <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                    <Link to="#">
                      <img
                        src={require("../assets/images/services/services-round-2.png")}
                        alt="Business consulting services"
                      />
                    </Link>
                    <div className="number-bg-round">
                      <span>02</span>
                    </div>
                  </div>
                  <div className="services-content services-content-style-1 text-center">
                    <h5 className="title">Project Strategy</h5>
                    <p className="description">
                      Define clear objectives, roadmap, and technology stack to build a scalable, goal-focused strategy tailored to client requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-services">
                <div className="services-inner">
                  <div className="thumbnail thumbnail-rounded border-top-left hover-animation">
                    <Link to="#">
                      <img
                        src={require("../assets/images/services/services-round-3.png")}
                        alt="Business consulting services"
                      />
                    </Link>
                    <div className="number-bg-round">
                      <span>03</span>
                    </div>
                  </div>
                  <div className="services-content services-content-style-1 text-center">
                    <h5 className="title">Campaign Design</h5>
                    <p className="description">
                      Craft targeted, creative campaigns with data-driven insights to maximize engagement, brand impact, and conversion efficiency
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tmp Servisec Processs Area Two End */}

      {/* tmp product area start */}
      {/* <div className="tmp-product-area tmp-section-gapTop bg-product-1">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head color-white">
                <div className="section-sub-title center-title">
                  <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Corporate_service"
                  />
                  <span className="subtitle">OUR PORTFOLIO</span>
                </div>
                <h2 className="title split-collab">
                  Let's Check Our Best Works{" "}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container-full">
          <div className="row">
            <div className="col-lg-12">
              product swiper area start
              <div className="product-swiper-area-one">
                <div className="swiper mySwiper-portfolio-1">
                  <div className="swiper-wrapper">
                    <div className="swiper-slide">
                      single product area start
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                      >
                        <Link to="/project/details" className="thumbnail">
                          <img
                            src={require("../assets/images/portfolio/portfolio-1.png")}
                            alt="corporate_business"
                          />
                        </Link>
                        <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Corporate Design</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div>
                      </div>
                      single product area end
                    </div>
                    <div className="swiper-slide">
                      single product area start
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                      >
                        <Link to="/project/details" className="thumbnail">
                          <img
                            src={require("../assets/images/portfolio/portfolio-2.png")}
                            alt="corporate_business"
                          />
                        </Link>
                        <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Executive Design Kit</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div>
                      </div>
                      single product area end
                    </div>
                    <div className="swiper-slide">
                      single product area start
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                      >
                        <Link to="/project/details" className="thumbnail">
                          <img
                            src={require("../assets/images/portfolio/portfolio-3.png")}
                            alt="corporate_business"
                          />
                        </Link>
                        <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Theme Pack</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div>
                      </div>
                      single product area end
                    </div>
                    <div className="swiper-slide">
                      single product area start
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                      >
                        <Link to="/project/details" className="thumbnail">
                          <img
                            src={require("../assets/images/portfolio/portfolio-4.png")}
                            alt="corporate_business"
                          />
                        </Link>
                        <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Executive Layout Set</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div>
                      </div>
                      single product area end
                    </div>
                    <div className="swiper-slide">
                      single product area start
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                      >
                        <Link to="/project/details" className="thumbnail">
                          <img
                            src={require("../assets/images/portfolio/portfolio-5.png")}
                            alt="corporate_business"
                          />
                        </Link>
                        <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Professional Design</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div>
                      </div>
                      single product area end
                    </div>
                    <div className="swiper-slide">
                      single product area start
                      <div
                        className="signle-product-start"
                        data-tmp-cursor="lg text-secondary transparent fw-bold"
                        data-tmp-cursor-icon="fa-solid fa-arrow-up-right"
                      >
                        <Link to="/project/details" className="thumbnail">
                          <img
                            src={require("../assets/images/portfolio/portfolio-6.png")}
                            alt="corporate_business"
                          />
                        </Link>
                        <div className="inner-content">
                          <Link to="/project/details">
                            <h5 className="title">Business Layout Library</h5>
                          </Link>
                          <span className="designation">
                            Financial advisory
                          </span>
                          <div className="tag"></div>
                        </div>
                      </div>
                      single product area end
                    </div>
                  </div>
                  <div className="swiper-pagination"></div>
                  <div
                    className="swiper-button-next"
                    data-tmp-cursor="md transparent fw-bold"
                    data-tmp-cursor-text="Next"
                  ></div>
                  <div
                    className="swiper-button-prev"
                    data-tmp-cursor="md transparent fw-bold"
                    data-tmp-cursor-text="Prev"
                  ></div>
                </div>
              </div>
              product swiper area end
            </div>
          </div>
        </div>
      </div>
      tmp product area end */}

      {/* Tmp FAQ area Start  */}
      <div className="faq-area faq-style-one faq-bg-image bg_image tmp-section-gap mt-dec--180">
        <div className="container pt--180">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Corporate_service"
                  />
                  <span className="subtitle">QUESTION AND ANSWERS</span>
                </div>
                <h2 className="title split-collab">
                  Frequency Asked Questions
                </h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="thumbnail">
                <img
                  src={require("../assets/images/faq/faq-1.png")}
                  alt="Business Consulting FAQ"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="faq-accordion">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <div
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        role="button"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <div className="accordion-button-left">
                          <i className="fa-regular fa-question"></i>
                          <span>
                            What we serve with IT and exam infrastructure solutions?
                          </span>
                        </div>
                        <div className="accordion-button-right">
                          <i className="fa-sharp fa-light fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Starparth serves educational institutions, corporates, government bodies, and growing businesses across industries by delivering tailored IT services, exam infrastructure, and digital solutions designed for scalability, security, and efficiency.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <div
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        role="button"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <div className="accordion-button-left">
                          <i className="fa-regular fa-question"></i>
                          <span>How does Starparth ensure effective project delivery?</span>
                        </div>
                        <div className="accordion-button-right">
                          <i className="fa-sharp fa-light fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        We follow a structured process—starting with client meetings to understand goals, followed by strategic planning, campaign design, and seamless execution—ensuring each project is aligned, measurable, and results-driven.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <div
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        role="button"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <div className="accordion-button-left">
                          <i className="fa-regular fa-question"></i>
                          <span>
                            Do we help with both digital marketing and financial planning?
                          </span>
                        </div>
                        <div className="accordion-button-right">
                          <i className="fa-sharp fa-light fa-arrow-right"></i>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Yes, Starparth provides both services. We drive business growth through powerful digital marketing campaigns and guide individuals or businesses with personalized financial planning and smart investment strategies.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="faq-buttom">
                  <h4 className="title">Still Have More Questions?</h4>
                  <p>
                    Contact Our <Link to="#">Expert Support Team</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tmp FAQ area Start  */}

      {/* Start Main Counter up-5 Area  */}
      <div className="tmp-counterup-area tmp-section-gapTop " style={{marginBottom : "50px"}} ref={counterRef}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Corporate_service"
                  />
                  <span className="subtitle">150+ Trusted</span>
                </div>
                <h2 className="title split-collab">HappyHey, Cortana.  customers</h2>
              </div>
            </div>
          </div>
          <div className="row g-5 mt--20 counter_animation">
            <div className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim">
              <div className="count-box counter-style-4 text-center">
                <div>
                  <h3 className="title">
                    {/*<span className="counter">100</span>+*/}
                    <span className="counter">{counters.clients}</span>+
                  </h3>
                </div>
                <h5 className="counter-title">Happy Clients.</h5>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim"
              data-sal-delay="100"
            >
              <div className="count-box counter-style-4 text-center">
                <div>
                  <h3 className="title">
                    {/*<span className="counter">50</span>+*/}
                    <span className="counter">{counters.employees}</span>+
                  </h3>
                </div>
                <h5 className="counter-title">Employees</h5>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim"
              data-sal-delay="200"
            >
              <div className="count-box counter-style-4 text-center">
                <div>
                  <h3 className="title">
                    {/*<span className="counter">70</span>+*/}
                    <span className="counter">{counters.programs}</span>+
                  </h3>
                </div>
                <h5 className="counter-title">Useful Programs</h5>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12 counter__anim"
              data-sal-delay="300"
            >
              <div className="count-box counter-style-4 text-center">
                <div>
                  <h3 className="title">
                    {/*<span className="counter">300</span>+*/}
                    <span className="counter">{counters.exams}</span>+
                  </h3>
                </div>
                <h5 className="counter-title">Exam Solutions Exp.</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Main Counter up-5 Area  */}

      {/* Start team area  */}
      {/* <div className="team-area tmp-section-gap bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title center-title">
                  {/* <img src={require("../assets/images/services/section-custom-menubar.png")} alt="Corporate services"/> */}
                  {/* <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Corporate services"
                  />
                  <span>OUR TEAM</span>
                </div>
                <h2 className="section-title split-collab">
                  Meet Our Team
                </h2>
              </div>
            </div>
          </div> */}
          {/* <div className="row g-5">
            <div
              style={{ opacity: 1 , textAlign: "center"}}
              className="col-lg-6 col-md-6 col-sm-12 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-team">
                <Link
                  to="/team/details"
                  className="thumbnail"
                  data-tmp-cursor="lg transparent fw-bold"
                  data-tmp-cursor-text="View Details"
                >
                  <img
                  style={{resize:"contain", width:"50%" , height : "410px"}}
                    src={require("../assets/Straff_images/Ritesh_sir.png")}
                    alt="Corporate team"
                  />
                </Link>
                <div className="content">
                  <div className="team-name content-with-bg">
                    <Link to="#" className="name-area">
                      <h6 className="name">Mr. Ritesh Joshi</h6>
                    </Link>
                    <div className="designation">CEO & Founder</div>
                  </div>
                  {/* <div className="share-icon-style-one">
                    <ul className="social-icons social-icons-with-bg">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                    <i className="fa-sharp fa-solid fa-share-nodes"></i>
                  </div> */}
                {/* </div>
              </div>
            </div>
            <div
              style={{ opacity: 1 , textAlign: "center"}}
              className="col-lg-6 col-md-6 col-sm-12 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-team">
                <Link
                  to="/team/details"
                  className="thumbnail"
                  data-tmp-cursor="lg transparent fw-bold"
                  data-tmp-cursor-text="View Details"
                >
                  <img
                  style={{resize:"contain", width:"50%" , height : "410px"}}
                    src={require("../assets/Straff_images/Ritu_Mam.png")}
                    alt="Corporate team"
                  />
                </Link>
                <div className="content" >
                  <div className="team-name content-with-bg">
                    <Link to="#" className="name-area">
                      <h6 className="name">Mrs. Ritu Joshi</h6>
                    </Link>
                    <div className="designation">Marketing Head</div>
                  </div> */}
                  {/* <div className="share-icon-style-one">
                    <ul className="social-icons social-icons-with-bg">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                    <i className="fa-sharp fa-solid fa-share-nodes"></i>
                  </div> */}
                {/* </div>
              </div>
            </div> */} 
            {/* <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-team">
                <Link
                  to="/team/details"
                  className="thumbnail"
                  data-tmp-cursor="lg transparent fw-bold"
                  data-tmp-cursor-text="View Details"
                >
                  <img
                    src={require("../assets/images/team/team-1.png")}
                    alt="Corporate team"
                  />
                </Link>
                <div className="content">
                  <div className="team-name content-with-bg">
                    <Link to="#" className="name-area">
                      <h6 className="name">William John</h6>
                    </Link>
                    <div className="designation">CEO & Founder</div>
                  </div>
                  <div className="share-icon-style-one">
                    <ul className="social-icons social-icons-with-bg">
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="fa-brands fa-twitter"></i>
                        </Link>
                      </li>
                    </ul>
                    <i className="fa-sharp fa-solid fa-share-nodes"></i>
                  </div>
                </div>
              </div>
            </div> */}
          {/* </div> */}
        {/* </div> */}
      {/* // </div>  */}
      {/* End team area  */}

      {/* Start Testimonial with brand  */}
      <div className="testimonial-with-brand bg-1 bg_image">
        {/* Start Testimonial Area  */}
        <div className="testimonial-brand-area tmp-section-gapTop">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="testimonials-button-area">
                  <div className="section-head text-align-left">
                    <div className="section-sub-title">
                      <img
                        src={require("../assets/images/services/section-custom-menubar.png")}
                        alt="Corporate_service"
                      />
                      <span className="subtitle">Client’s Testimonials</span>
                    </div>
                    <h2 className="title split-collab">
                      What People Say About <br></br> Our Company
                    </h2>
                  </div>

                  <div className="button-next-prev">
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                {/* Slider main container */}
                <div className="swiper-style-one tmp-section-gapBottom">
                  <div className="swiper-container-style-two">
                    {/* Additional required wrapper */}
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                "Starparth transformed our IT infrastructure completely. Their team is proactive, knowledgeable, and delivers scalable solutions that actually work"
                              </p>
                              <div className="content content-without-bg">
                                <div className="name">Saksham Gupta</div>
                                <div className="designation">
                                  CEO &amp; Kamtech Associates
                                </div>
                              </div>
                            </div>
                            {/* <div className="thumbnail">
                              <img
                                src={require("../assets/images/testimonial/testimonial-1.jpg")}
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                "We partnered with Starparth for an all-India exam. Their setup was flawless—secure, organized, and stress-free. Highly recommended."
                              </p>

                              <div className="content content-without-bg">
                                <div className="name">Anuj Kumar</div>
                                <div className="designation">Delhi Bytes , Operations Manager</div>
                              </div>
                            </div>
                            {/* <div className="thumbnail">
                              <img
                                src={require("../assets/images/testimonial/testimonial-2.jpg")}
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                "Starparth helped us streamline our finances and build a solid investment plan. Their insights and strategies gave us clarity and confidence for the future."
                              </p>
                              <div className="content content-without-bg">
                                <div className="name">Bhanu Chouhan</div>
                                <div className="designation">Sr. Software Developer</div>
                              </div>
                            </div>
                            {/* <div className="thumbnail">
                              <img
                                src={require("../assets/images/testimonial/testimonial-1.jpg")}
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="swiper-slide">
                        <div className="single-card card-horizontal">
                          <div className="card-inner">
                            <div className="content">
                              <div className="rating rating-style-three">
                                <div className="stars-group">
                                  <div className="star">
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star"></i>
                                    <i className="fa-solid fa-star-half-stroke"></i>
                                  </div>
                                </div>
                              </div>
                              <p className="description">
                                "Thanks to Starparth's digital team, our brand visibility skyrocketed. Their campaigns brought in real engagement and consistent leads. Excellent ROI and professionalism!"
                              </p>
                              <div className="content content-without-bg">
                                <div className="name">Vinod Jain</div>
                                <div className="designation">
                                  Head Of CP Cards
                                </div>
                              </div>
                            </div>
                            {/* <div className="thumbnail">
                              <img
                                src={require("../assets/images/testimonial/testimonial-2.jpg")}
                                alt="testimonial"
                              />
                              <div className="icon icon-quote">
                                <i className="fa-duotone fa-quote-left"></i>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* If we need navigation buttons */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Testimonial Area  */}

        {/* Start Brand Area  */}
        <div
          style={{ opacity: 1 }}
          className="brand-area tmp-section-gapBottom"
        >
          <div style={{ opacity: 1 }} className="container">
            <div style={{ opacity: 1 }} className="row">
              <div style={{ opacity: 1 }} className="col-lg-12">
                <div
                  style={{ opacity: 1 }}
                  className="brand-inner tmp-section-gapTop"
                >
                  <ul
                    style={{ opacity: 1 }}
                    className="brand-list brand-style-1 justify-content-center justify-content-lg-between"
                  >
                    <li
                      style={{ opacity: 1 }}
                      data-sal-delay="150"
                      data-sal="slide-up"
                      data-sal-duration="800"
                    >
                      <Link to="#">
                        <img
                        style={{ width: "auto" , height : "70px"}}
                          src={require("../assets/images/brand/Bytes-logo.png")}
                          alt="Bytes Image"
                        />
                      </Link>
                    </li>

                    <li
                      style={{ opacity: 1 }}
                      data-sal-delay="250"
                      data-sal="slide-up"
                      data-sal-duration="800"
                    >
                      <Link to="#">
                        <img
                        style={{ width: "auto" , height : "70px"}}
                          src={require("../assets/images/brand/Career-Foresight-logo.png")}
                          alt="Career-Foresight Image"
                        />
                      </Link>
                    </li>

                    <li
                      style={{ opacity: 1 }}
                      data-sal-delay="350"
                      data-sal="slide-up"
                      data-sal-duration="800"
                    >
                      <Link to="#">
                        <img
                        style={{ width: "auto" , height : "70px" }}
                          src={require("../assets/images/brand/netcom-logo.png")}
                          alt="Netcom Image"
                        />
                      </Link>
                    </li>

                    <li
                      style={{ opacity: 1 }}
                      data-sal-delay="450"
                      data-sal="slide-up"
                      data-sal-duration="800"
                    >
                      <Link to="#">
                        <img
                        style={{ width: "auto" , height : "70px" }}
                          src={require("../assets/images/brand/netparam-logo.png")}
                          alt="Netparam Image"
                        />
                      </Link>
                    </li>
                    <li
                      style={{ opacity: 1 }}
                      data-sal-delay="550"
                      data-sal="slide-up"
                      data-sal-duration="800"
                    >
                      <Link to="#">
                        <img
                          style={{ width: "auto" , height : "70px" }}
                          src={require("../assets/images/brand/Orlando-Academy-logo.png")}
                          alt="Orlando-Academy Image"
                        />
                      </Link>
                    </li>
                        <li
                      style={{ opacity: 1 }}
                      data-sal-delay="550"
                      data-sal="slide-up"
                      data-sal-duration="800"
                    >
                      <Link to="#">
                        <img
                          style={{ width: "auto" , height : "80px" }}
                          src={require("../assets/images/brand/SMART-AGE-COMPUTERS-logo.png")}
                          alt="SMART-AGE-COMPUTERS-logo"
                        />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Brand Area  */}
      </div>
      {/* End Testimonial with brand  */}

      {/* Start Contact Area  */}
      <div
        style={{ opacity: 1,marginBottom:"50px" }}
        className="contact-area-three tmp-section-gapTop"
        
      >
        <div style={{ opacity: 1 }} className="bg-shape">
          <img
            src={require("../assets/images/cta/02.png")}
            alt="bussiness-contact"
          />
        </div>
        <div style={{ opacity: 1 }} className="container">
          <div style={{ opacity: 1 }} className="row g-5">
            <div style={{ opacity: 1 }} className="col-lg-5">
              <div style={{ opacity: 1 }} className="contact-inner">
                <div
                  style={{ opacity: 1 }}
                  className="section-head section-head-one-side text-align-left"
                  data-sal-delay="150"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <span style={{ opacity: 1 }} className="title">
                    Contact Us
                  </span>
                  <p style={{ opacity: 1 }} className="description">
                    Have questions or ready to get started? Reach out to our team—we're here to help you grow and succeed.

                  </p>
                </div>
                
                {/* <div
                  style={{ opacity: 1 }}
                  className="section-head section-head-one-side text-align-left"
                >
                  <span style={{ opacity: 1 }} className="title">
                    Contact Us
                  </span>
                  <p style={{ opacity: 1 }} className="description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolor magnaaliqua.
                  </p>
                </div> */}
                 <ul
                  style={{ opacity: 1 }}
                  className="ft-link ft-link-style-three"
                  data-sal-delay="250"
                  data-sal="slide-up"
                  data-sal-duration="800" 
                >
                  <li>
                    <div
                      style={{ opacity: 1 }}
                      className="single-contact background-transparent"
                    >
                      <div className="icon">
                        <i className="fa-light fa-phone"></i>
                      </div>
                      <div style={{ opacity: 1 }} className="content">
                        <span>Call Us</span>
                        <Link className="contact-here" to="#">
                          +919057000445 &nbsp; | &nbsp; +919057000446`
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{ opacity: 1 }}
                      className="single-contact background-transparent"
                    >
                      <div style={{ opacity: 1 }} className="icon">
                        <i className="fa-solid fa-envelope-open-text"></i>
                      </div>
                      <div style={{ opacity: 1 }} className="content">
                        <span>E-mail</span>
                        <Link className="contact-here" to="#">
                          info@starparth.com
                        </Link>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      style={{ opacity: 1 }}
                      className="single-contact background-transparent" >
                      <div style={{ opacity: 1 }} className="icon">
                        <i className="fa-solid fa-map-location-dot"></i>
                      </div>
                      <div style={{ opacity: 1 }} className="content">
                        <span>Address</span>
                        <Link className="contact-here" to="#">
                          G2 Aanchal Apartment  1/55 Roshan Marg <br></br> Chitrakoot Jaipur Rajasthan 302021
                        </Link>
                      </div>
                    </div>
                  </li>
                </ul>


                {/* <ul
                  style={{ opacity: 1 }}
                  className="ft-link ft-link-style-three"
                >
                  <li>
                    <div
                      style={{ opacity: 1 }}
                      className="single-contact background-transparent"
                    >
                      <div className="icon">
                        <i className="fa-light fa-phone"></i>
                      </div>
                      <div style={{ opacity: 1 }} className="content">
                        <span>Call Us</span>
                        <Link className="contact-here" to="#">
                          +123 34598768
                        </Link>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div
                      style={{ opacity: 1 }}
                      className="single-contact background-transparent"
                    >
                      <div style={{ opacity: 1 }} className="icon">
                        <i className="fa-solid fa-envelope-open-text"></i>
                      </div>

                      <div style={{ opacity: 1 }} className="content">
                        <span>E-mail</span>
                        <Link className="contact-here" to="#">
                          info@uibundle.com
                        </Link>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div
                      style={{ opacity: 1 }}
                      className="single-contact background-transparent"
                    >
                      <div style={{ opacity: 1 }} className="icon">
                        <i className="fa-solid fa-map-location-dot"></i>
                      </div>
                      <div style={{ opacity: 1 }} className="content">
                        <span>Address</span>
                        <Link className="contact-here" to="#">
                          25/5 Double Street, Texas Houston USA
                        </Link>
                      </div>
                    </div>
                  </li>
                </ul> */}
                 <div
                  style={{ opacity: 1 }}
                  className="tmp-tag-list tag-list-one"
                  data-sal-delay="350"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <Link className="tag-list" to="https://www.facebook.com/starparthexamination/">
                    Facebook
                  </Link>
                  <Link className="tag-list" to="https://x.com/Starparthtech">
                    Twitter
                  </Link>
                  <Link className="tag-list" to="#">
                    Linkedin
                  </Link>
                  <Link className="tag-list" to="#">
                    Skype
                  </Link>
                  <Link className="tag-list" to="#">
                    Pinterest
                  </Link>
                </div>

                {/* <div
                  style={{ opacity: 1 }}
                  className="tmp-tag-list tag-list-one"
                >
                  <Link className="tag-list" to="#">
                    Facebook
                  </Link>
                  <Link className="tag-list" to="#">
                    Twitter
                  </Link>
                  <Link className="tag-list" to="#">
                    Linkedin
                  </Link>
                  <Link className="tag-list" to="#">
                    Skype
                  </Link>
                  <Link className="tag-list" to="#">
                    Pinterest
                  </Link>
                </div> */}
              </div>
            </div>
             <div
              style={{ opacity: 1 }}
              className="col-lg-7"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div style={{ opacity: 1 }} className="contact-inner">
                <div
                  style={{ opacity: 1 }}
                  className="section-head section-head-one-side text-align-left"
                >
                  <span className="title">GET IN TOUCH</span>
                  <p className="description">
                    Let’s connect and explore how Hey, Cortana. Starparth can bring your vision to life.
                    <br/>
                  </p>
                </div>
                <div style={{ opacity: 1 }} className="contact-form style-two">
                  <form id="contact-form" onSubmit={handleSubmit} noValidate>
                    <div className="contact-form-wrapper row">
                        <div className="form-honeypot" aria-hidden="true">
                          <input type="text" name="company_website" tabIndex={-1}
                            autoComplete="off" {...fieldProps("company_website")} />
                        </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="name"
                            placeholder="Name"
                            id="contact-name"
                            type="text"
                            value={formData.name}
	                          onChange={handleInputChange}
                            required
                          />
                            <Err name="name" />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="phone"
                            placeholder="Phone"
                            type="text"
                            value={formData.phone}
	                          onChange={handleInputChange}
                            required
                          />
                            <Err name="phone" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="email"
                            placeholder="Email"
                            type="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                            <Err name="email" />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            type="text"
                            id="subject"
                            placeholder="Website"
                            name="website"
                            value={formData.website}
	                          onChange={handleInputChange}
                          />
                            <Err name="website" />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            className="input-field"
                            placeholder="How Hey, Cortana. can we help"
                            name="message"
                            id="contact-message"
                            value={formData.message}
	                          onChange={handleInputChange}
                          ></textarea>
                            <Err name="message" />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-submit-group">
                          <button
                            name="submit"
                            className="tmp-btn btn-primary"
                            type="submit"
                            id="submit"
	                          disabled={isLoading}
                          >
                            {isLoading ? 'Sending…' : 'Submit Now'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            
            {/* <div
              style={{ opacity: 1 }}
              className="col-lg-7"
            >
              <div style={{ opacity: 1 }} className="contact-inner">
                <div
                  style={{ opacity: 1 }}
                  className="section-head section-head-one-side text-align-left"
                >
                  <span className="title">GET IN TOUCH</span>
                  <p className="description">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolor magnaaliqua.
                  </p>
                </div>
                <div style={{ opacity: 1 }} className="contact-form style-two">
                  <form id="contact-form" action="#">
                    <div className="contact-form-wrapper row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="contact-name"
                            placeholder="Name"
                            id="contact-name"
                            type="text"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="contact-phone"
                            placeholder="Phone"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            name="contact-phone"
                            placeholder="Email"
                            type="email"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            className="input-field"
                            type="text"
                            id="subject"
                            placeholder="Website"
                            name="Website"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            className="input-field"
                            placeholder="How can we help"
                            name="contact-message"
                            id="contact-message"
                          ></textarea>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="form-submit-group">
                          <button
                            name="submit"
                            className="tmp-btn btn-primary"
                            type="submit"
                            id="submit"
                          >
                            Submit Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* End Contact Area  */}

      {/* Tmp Blog Area Start  */}
      {/* <div style={{ opacity: 1 }} className="tmp-blog-area tmp-section-gap">
        <div style={{ opacity: 1 }} className="container">
          <div style={{ opacity: 1 }} className="row">
            <div style={{ opacity: 1 }} className="col-lg-12">
              <div style={{ opacity: 1 }} className="section-head">
                <div
                  style={{ opacity: 1 }}
                  className="section-sub-title center-title"
                >
                  <img
                    src={require("../assets/images/services/section-custom-menubar.png")}
                    alt="Corporate_service"
                  />
                  <span className="subtitle">LATEST BLOG</span>
                </div>
                <h2 className="title split-collab">Latest News & Articles</h2>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-12 col1-2"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-blog">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src={require("../assets/images/blog/blog-2.png")}
                        alt="Business Consulting Blog"
                      />
                    </Link>
                    <div className="pmt-blog-meta">
                      <ul className="all-meta">
                        <li className="date">
                          <span>20</span>
                        </li>
                        <li className="month">
                          <span>JAN</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">Sultan Ahmed</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title">
                          Consulted admitting wooded is power acuteness.
                        </h4>
                      </Link>
                      <p className="description">
                        There are many variations of passages of Lorem Ipsum
                        available, but the majority have suffered.
                      </p>
                    </div>
                    <Link className="btn-read-more" to="/blog/details">
                      <span className="read-more-text">Read More</span>
                      <span className="read-more-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-12 col1-2"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-blog">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src={require("../assets/images/blog/blog-3.png")}
                        alt="Business Consulting Blog"
                      />
                    </Link>
                    <div className="pmt-blog-meta">
                      <ul className="all-meta">
                        <li className="date">
                          <span>20</span>
                        </li>
                        <li className="month">
                          <span>JAN</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">Sultan Ahmed</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title">
                          Grow your business strategy with business consulting.
                        </h4>
                      </Link>
                      <p className="description">
                        There are many variations of passages of Lorem Ipsum
                        available, but the majority have suffered.
                      </p>
                    </div>
                    <Link className="btn-read-more" to="/blog/details">
                      <span className="read-more-text">Read More</span>
                      <span className="read-more-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{ opacity: 1 }}
              className="col-lg-4 col-md-6 col-sm-12 col1-2"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-blog">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src={require("../assets/images/blog/blog-1.png")}
                        alt="Business Consulting Blog"
                      />
                    </Link>
                    <div className="pmt-blog-meta">
                      <ul className="all-meta">
                        <li className="date">
                          <span>20</span>
                        </li>
                        <li className="month">
                          <span>JAN</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">Sultan Ahmed</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title">
                          Facilis dolor eques about under official,presentism.
                        </h4>
                      </Link>
                      <p className="description">
                        There are many variations of passages of Lorem Ipsum
                        available, but the majority have suffered.
                      </p>
                    </div>
                    <Link className="btn-read-more" to="/blog/details">
                      <span className="read-more-text">Read More</span>
                      <span className="read-more-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* Tmp Blog Area Start  */}

      {/* Start Footer Area  */}
      {/* Start Footer Area  */}
      {/* <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="subscribe-area subscribe-style-1">
                <div className="subscribe-inner">
                  <div className="title">Subscribe to Newsletter</div>
                  <form action="#" className="newsletter-form-1 mt--40">
                    <input type="email" placeholder="Your Email" required />
                    <button type="submit" className="tmp-btn btn-primary">
                      Subscribe Now{" "}
                      <i className="fa-sharp fa-regular fa-paper-plane"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-main footer-style-one">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper border-right mr--20">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/images/logo/logo-02.svg" alt="logo" />
                      <img height="61" width="188" src="/assets/images/logo/starpath-logo.svg" alt="logo" />
                    </Link>
                  </div>

                  <p className="description">
                    Proin Pretium Sem Libero, Nec Aliquet Augue Lobortis In.
                    Phasellus Nibh Quam, Molestie Id Est Sit Amet, Luctus
                    Pulvinar
                  </p>

                  <div className="day-time">
                    <div className="icon">
                      <i className="fa-solid fa-alarm-clock"></i>
                    </div>
                    <div className="content">
                      <div className="day">Sunday - Friday:</div>
                      <div className="time">9:00 AM – 8:00 PM</div>
                    </div>
                  </div>

                  <ul className="social-icons solid-social-icons rounded-social-icons">
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h5 className="ft-title">Quick Link</h5>
                  <ul className="ft-link">
                    <li>
                      <Link to="/about">About Company</Link>
                    </li>
                    <li>
                      <Link to="/team"> Team</Link>
                    </li>
                    <li>
                      <Link to="/service">Our Services</Link>
                    </li>
                    <li>
                      <Link to="/blog">News & Media</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>

                    <li>
                      <Link to="/faq">Support</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper pr--15">
                  <h5 className="ft-title">Recent Post</h5>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src={require("../assets/images/footer/small-post.jpg")}
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Day tree hide from hath gathered multy
                        </h6>
                      </Link>
                    </div>
                  </div>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src={require("../assets/images/footer/small-post-2.jpg")}
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Saving Time Achieving Success in Business
                        </h6>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper">
                  <h5 className="ft-title">Official info:</h5>
                  <ul className="ft-link">
                    <li className="ft-location">
                      5919 Trussville Crossings Pkwy, new Dusting town, Austria
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-solid fa-envelope-open-text"></i>
                        </div>

                        <div className="content">
                          <span>E-mail:</span>
                          <Link to="mailto:webmaster@example.com">
                            info@uibundle.com
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-light fa-phone"></i>
                        </div>
                        <div className="content">
                          <span>Phone:</span>
                          <Link to="tel:+4733378901">+123 34598768</Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer> */}
      {/* <div className="copyright-area-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper">
                <p>
                  © Copyright 2024. All Rights Reserved by{" "}
                  <Link to="#">Themes-Park</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Footer Area  */}
      {/* End Footer Area  */}

      <div
        id="overlay_every-where"
        data-tmp-cursor="md text-black dark:text-white opacity-10"
        data-tmp-cursor-icon="fa-regular fa-x fa-fw"
      ></div>

      {/* progress area start */}
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
      {/* progress area end */}
    </div>
    </>
  );
}

export default Home;
